<template>
	<card class="is-card-table has-pagination has-table-borderless has-bottom-left-hidden" title="グループ一覧" icon="format-list-bulleted">
		<b-button slot="button" type="is-success" @click="onNewButtonClick">新規作成</b-button>
		<group-table-toolbar slot="toolbar" :customers="customers" @search-button-click="onSearchButtonClick"/>
		<group-table :data="data" :totalNum="totalNum" :isLoading="isLoading" :checkable="false"/>
	</card>
</template>

<script>
import Card from "@/components/Card";
import GroupTable from "@/components/GroupTable";
import GroupTableToolbar from "@/components/GroupTableToolbar";
import qs from 'qs';

export default {
	name: 'group',
	components: {
		Card,
		GroupTable,
		GroupTableToolbar,
	},
	data() {
		return {
			data: [],
			isLoading: false,
			totalNum: 0,
			customers: [],
		}
	},
	mounted() {
		this.init();
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['グループ管理']
		});
	},
	methods: {
		onNewButtonClick: function() {
			this.$router.push({ name: 'group-new' });
		},
		onSearchButtonClick: function(isHiddenContain, customerId) {
			this.getData(isHiddenContain, customerId);
		},
		init: function() {
			this.getData(0);
		},
		getData: async function(isHiddenContain = 0, customerId = '') {
			this.isLoading = true;
			let data = {
				"is_hidden_contain": isHiddenContain,
				"customer_id": customerId,
			};
			this.$utils.log(data);

			let ep = 'groups?' + qs.stringify(data);
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				if (!res.data.list) {
					this.data = [];
				} else {
					this.data = res.data.list;
				}
				this.totalNum = this.data.length;
				this.customers = res.data.customers;
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
	},
}
</script>

<style scoped>
</style>
